import { fetchTicketExpressCheckoutInfo } from './api';
import type { TicketContextType } from './types';

export const fetchDataAndUpdateTicketData =
    (
        setIsFetchComplete: (isComplete: boolean) => void,
        setTicketData: (ticketData: TicketContextType) => void,
    ) =>
    async (url: string) => {
        setIsFetchComplete(false);
        try {
            const response = await fetchTicketExpressCheckoutInfo(url);
            const expressCheckoutResponse = {
                compactCheckoutDisqualifications:
                    response.data.event.compactCheckoutDisqualifications,
                panelDisplayPrice:
                    response.data.components.conversionBar.panelDisplayPrice,
                ticketClasses:
                    response.data.event_listing_response.tickets.ticketClasses,
            };
            setTicketData(expressCheckoutResponse);
        } catch (error) {
            console.error('Error fetching data:', error);
        } finally {
            setIsFetchComplete(true);
        }
    };
